import { TextField as Mui4TextField, TextFieldProps as Mui4TextFieldPropsType } from '@material-ui/core'
import { default as Mui5TextField, TextFieldProps as Mui5TextFieldPropsType } from '@mui/material/TextField'
import { forwardRef } from 'react'
import { Icon } from '../core/Icon'
import { useComponentVersion } from '../hooks'

const IconComponent = (props) => {
  return <Icon icon={'keyboard_arrow_down'} {...props} />
}

// * MUI TextField API Spec  https://mui.com/material-ui/api/text-field/
export enum OsTextFieldVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export type TextFieldProps = Omit<Mui4TextFieldPropsType, 'variant' | 'color'> & {
  variant?: Mui5TextFieldPropsType['variant'] | Mui4TextFieldPropsType['variant']
  color?: Mui5TextFieldPropsType['color'] | Mui4TextFieldPropsType['color']
  minRows?: Mui5TextFieldPropsType['minRows']
  maxRows?: Mui5TextFieldPropsType['maxRows']
  disableLabel?: boolean
}
const V2_TEXT_COLORS = ['primary', 'secondary']
export const TextField = forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => {
  const version = useComponentVersion('text_field')

  switch (version) {
    case OsTextFieldVersion.V2: {
      const {
        InputProps,
        SelectProps,
        label,
        color,
        InputLabelProps,
        disableLabel,
        variant = 'outlined',
        ...rest
      } = props
      const InputProps5: Mui5TextFieldPropsType['InputProps'] = InputProps as Mui5TextFieldPropsType['InputProps']
      const SelectProps5: Mui5TextFieldPropsType['SelectProps'] = {
        IconComponent,
        ...SelectProps,
      } as Mui5TextFieldPropsType['SelectProps']
      const labelProp = disableLabel ? undefined : label
      return (
        <Mui5TextField
          ref={ref}
          variant={variant}
          InputProps={InputProps5}
          SelectProps={SelectProps5}
          color={color || 'secondary'}
          InputLabelProps={{
            shrink: true,
            ...InputLabelProps,
          }}
          label={labelProp}
          {...rest}
        />
      )
    }
    default: {
      const { color, variant, disableLabel, ...rest } = props
      const mui4Props: Mui4TextFieldPropsType = {
        ...rest,
        variant: variant as Mui4TextFieldPropsType['variant'],
        color: color && V2_TEXT_COLORS.includes(color) ? (color as Mui4TextFieldPropsType['color']) : 'secondary',
      }
      return <Mui4TextField ref={ref} {...mui4Props} />
    }
  }
})
